/**
 * About Page Module
 */

import router from './router.js';

class AboutPage {
  constructor() {
    this.container = null;
  }

  render() {
    const app = document.getElementById('app');
    const hero = document.getElementById('hero');
    if (app) app.style.display = 'none';
    if (hero) hero.style.display = 'none';

    if (!this.container) {
      this.container = document.createElement('div');
      this.container.id = 'about-page';
      this.container.className = 'static-page';
      this.setupEventListeners();
    }

    this.container.innerHTML = `
      <div class="static-page-header">
        <button class="back-btn" id="back-btn" aria-label="Go back">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
          Back
        </button>
        <h1 class="static-page-title">About Anilora</h1>
      </div>

      <div class="static-page-content">
        <section class="about-hero-section">
          <h2>Your Destination for Beautiful Wallpapers</h2>
          <p>Anilora is a free platform dedicated to delivering stunning, high-quality wallpapers for your desktop and mobile devices. No watermarks, no sign-up walls &mdash; just beautiful imagery at your fingertips.</p>
        </section>

        <section class="about-section">
          <h2>Our Mission</h2>
          <p>We believe everyone deserves a beautiful digital space. Our mission is to curate and deliver the finest wallpapers across a wide range of categories, making it easy to personalize your devices with artwork you love.</p>
        </section>

        <section class="about-section">
          <h2>What We Offer</h2>
          <div class="about-features">
            <div class="about-feature">
              <div class="about-feature-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5"></circle>
                  <polyline points="21 15 16 10 5 21"></polyline>
                </svg>
              </div>
              <h3>Curated Collection</h3>
              <p>Every wallpaper is hand-picked for quality, resolution, and aesthetic appeal.</p>
            </div>
            <div class="about-feature">
              <div class="about-feature-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                  <line x1="7" y1="7" x2="7.01" y2="7"></line>
                </svg>
              </div>
              <h3>Organized Categories</h3>
              <p>Browse by category &mdash; from nature and anime to fantasy and aesthetic &mdash; to find exactly what you're looking for.</p>
            </div>
            <div class="about-feature">
              <div class="about-feature-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                </svg>
              </div>
              <h3>Community Ratings</h3>
              <p>Rate and like your favorites. Our community-driven ratings help surface the best wallpapers.</p>
            </div>
            <div class="about-feature">
              <div class="about-feature-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
              </div>
              <h3>Free Downloads</h3>
              <p>Download wallpapers in multiple resolutions, completely free and without watermarks.</p>
            </div>
          </div>
        </section>

        <section class="about-section">
          <h2>Get in Touch</h2>
          <p>Have questions, suggestions, or want to contribute wallpapers? We'd love to hear from you. Visit our <a href="/contact" class="static-page-link" data-route="/contact">contact page</a> to get in touch.</p>
        </section>
      </div>
    `;

    if (!document.body.contains(this.container)) {
      const footer = document.querySelector('.footer');
      if (footer) {
        document.body.insertBefore(this.container, footer);
      } else {
        document.body.appendChild(this.container);
      }
    }

    this.container.style.display = 'block';
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  setupEventListeners() {
    this.container.addEventListener('click', (e) => {
      if (e.target.closest('#back-btn')) {
        router.back();
        return;
      }

      const routeLink = e.target.closest('[data-route]');
      if (routeLink) {
        e.preventDefault();
        router.navigate(routeLink.dataset.route);
      }
    });
  }

  hide() {
    if (this.container) {
      this.container.style.display = 'none';
    }
    const app = document.getElementById('app');
    const hero = document.getElementById('hero');
    if (app) app.style.display = 'block';
    if (hero) hero.style.display = 'block';
  }
}

export default new AboutPage();
